/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OAuthAppRotationTypeEnum = 'INDIVIDUAL' | 'FLEET';

export const OAuthAppRotationTypeEnum = {

    INDIVIDUAL: 'INDIVIDUAL' as OAuthAppRotationTypeEnum,

    FLEET: 'FLEET' as OAuthAppRotationTypeEnum
};

